
import { throwError as observableThrowError } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

@Injectable()
export class BatchUploadService {
    srvUrl: string;
    constructor(private http: Http) {
        this.srvUrl = `${environment.api.url}`;
     }
    
   serviceCall(data:string) {
        let url = this.srvUrl;
        //console.log(url);
        return this.http.post(url, data)
            .pipe(catchError(this.handleError))
    }


    private handleError(error: any) {
        let errMsg = '';
        if (error.message) {
            errMsg = error.message;
        } else {
            errMsg = error.status ? '${error.status} - ${error.statusText}' : 'Server error';
        }
        return observableThrowError(errMsg);
    }   
}
